<template>
  <w-main-template>
    <!-- side -->
    <div slot="sideContent" style="height: 100%;" @click="hideSearchPopup">
      <w-log-tree ref="logTree" :search-tags="searchTags" :select-options="selectOptions" />
    </div>
    <!-- title -->
    <w-main-title slot="mainTitle" :title="selectedNode.label">
      <div slot="rightTool">
        <w-datetime-range-button ref="datepicker" />
        <w-report-button/>
      </div>
    </w-main-title>
    <!-- main -->
    <div slot="mainContent" class="page-container-content tabgroup">
      <w-tool-tabs v-model="activeTabName" @tab-click="hideSearchPopup">
        <el-tab-pane :label="tabs.search.label" :name="tabs.search.name" class="h100 w100">
          <div class="full-wrapper" @click="hideSearchPopup">
            <el-scrollbar :ref="scrollbarRef">
              <div class="full">
                <w-log-analysis-table ref="logTable" :active="tabs.search.active" :show-search-popover="showSearchPopover" :select-options="selectOptions"
                  @change-tree-data="changeTreeData" @change-popover-show="changePopoverShow" @change-search-tags="changeSearchTags" />
              </div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="tabs['keyword-map'].label" :name="tabs['keyword-map'].name" class="h100 w100">
          <div class="full-wrapper">
            <div style="width:calc(100% - 310px); margin-left:0px; float:left">
              <div class="full-f-chart" style="height: calc(100vh - 204px);">
                <w-log-word-chart :active="tabs['keyword-map'].active" @wordCount="setWordCount"></w-log-word-chart>
              </div>
            </div>
            <div style="width:310px; float:left;">
              <w-log-word-chart-event-info class="full" style="height: calc(100vh - 215px); margin-left: -22px" :wordCount="wordCount" @wordClick="wordClick"></w-log-word-chart-event-info>
            </div>
          </div>
        </el-tab-pane>
      </w-tool-tabs>
      <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
    </div>
  </w-main-template>
</template>

<script>
import { mapGetters } from 'vuex';

import RouterTab from '@/mixins/router/tab';
import ScrollbarMixin from '@/mixins/scrollbar';
import msgUtil from '@/utils/message';
import LogAPI from '@/api/log/common';

import WMainTemplate from '@/components/template/MainTemplate';
import WMainTitle from '@/components/template/MainTitle';
import WDatetimeRangeButton from '@/components/button/DatetimeRangeButton';
import WReportButton from '@/components/button/ReportButton';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WLogAnalysisTable from './components/LogAnalysisTable';
import WLogTree from './components/LogTree';
import WLogWordChart from './components/analysis/LogWordChart';
import WLogWordChartEventInfo from './components/analysis/LogWordChartEventInfo';

export default {
  name: 'WLog',
  mixins: [RouterTab, ScrollbarMixin],
  components: {
    WMainTemplate,
    WMainTitle,
    WReportButton,
    WDatetimeRangeButton,
    WLogTree,
    WEventlevelCell,
    WLogAnalysisTable,
    WLogWordChart,
    WLogWordChartEventInfo,
  },
  data() {
    return {
      tabs: {
        search: {
          name: 'search',
          label: '조회',
          active: false,
          default: true,
        },
        'keyword-map': {
          name: 'keyword-map',
          label: '키워드 맵',
          active: false,
        },
      },
      showSearchTool: false,
      showSearchPopover: false,
      logChartDatas: [],
      wordCount: [],
      searchTags: [],
      selectOptions: [],
      logDefaultQuickDatetime: [
        [
          { label: '오늘', type: 'fixed', value: 'today' },
          { label: '이번 주', type: 'fixed', value: 'thisWeek' },
          { label: '이번 달', type: 'fixed', value: 'thisMonth' },
          { label: '현재까지 주간', type: 'fixed', value: 'weekToDate' },
          { label: '현재까지 월간', type: 'fixed', value: 'monthToDate' },
        ],
        [
          { label: '어제', type: 'fixed', value: 'yesterday' },
          { label: '그제', type: 'fixed', value: 'beforeYesterday' },
          { label: '지난 주 오늘', type: 'fixed', value: 'todayLastWeek' },
          { label: '전 주', type: 'fixed', value: 'lastWeek' },
          { label: '전 월', type: 'fixed', value: 'lastMonth' },
        ],
        [
          { interval: 'minute', isRelative: true, label: '최근 15분', type: 'interval', value: 15 },
          { interval: 'minute', isRelative: true, label: '최근 30분', type: 'interval', value: 30 },
          { interval: 'hour', isRelative: true, label: '최근 1시간', type: 'interval', value: 1 },
          { interval: 'hour', isRelative: true, label: '최근 6시간', type: 'interval', value: 6 },
          { interval: 'hour', isRelative: true, label: '최근 12시간', type: 'interval', value: 12 },
          { interval: 'hour', isRelative: true, label: '최근 24시간', type: 'interval', value: 24 },
        ],
        [
          { interval: 'day', label: '최근 7일', type: 'interval', value: 7 },
          { interval: 'day', label: '최근 30일', type: 'interval', value: 30 },
          { interval: 'day', label: '최근 60일', type: 'interval', value: 60 },
        ],
      ],
    };
  },
  computed: mapGetters(['selectedNode', 'analysisDateParams']),
  created() {
    this.$store.dispatch('setInitialDatetimeRange', { type: 'fixed', value: 'today', label: '오늘' });
    LogAPI.getLogFilterFieldOptions().then((response) => {
      this.selectOptions = response.data.data;
    }).catch((e) => {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필터 필드', false));
      throw new Error(e);
    });
  },
  mounted() {
    // 로그분석 우측 상단 datepicker의 날짜 선택 범위를 조정한다.
    this.$refs.datepicker.defualtQuickDatetime = this.logDefaultQuickDatetime;
    this.setScrollData();
  },
  methods: {
    wordClick(data) { // test
      this.routeByTab(this.tabs.search.name, false);
      const message = {
        value: data,
        label: `메시지 : ${data}`,
        property: 'message',
      };
      this.$refs.logTable.addSearchTagFromKeywordMap(message);
    },
    setWordCount(item) {
      this.wordCount = item;
    },
    hideSearchPopup() {
      this.showSearchPopover = true;
    },
    changePopoverShow(isShow) {
      this.showSearchPopover = isShow;
    },
    changeTreeData() {
      this.$refs.logTree.loadCustomFilterData();
    },
    changeSearchTags(searchTags) {
      this.searchTags = searchTags;
    },
    initData() {
      this.changeTreeData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/log/index.vue